<ng-container [ngSwitch]="block.kind">
	<div *ngSwitchCase="'divider'" class="text-block text-block--divider">
		<hr class="text-block__rule" />
	</div>

	<typography
		*ngSwitchCase="'heading'"
		variant="h/3"
		class="text-block text-block--heading"
	>
		<app-report-inline-text
			[text]="block.text"
			[field]="field"
			[editorMode]="editorMode"
			[showEdited]="false"
			placeholder="Heading"
		></app-report-inline-text>
	</typography>

	<div
		*ngSwitchDefault
		class="text-block"
		[class.text-block--callout]="block.kind === 'callout'"
		[style.--text-block-accent]="themeColor"
		cdkOverlayOrigin
		#origin="cdkOverlayOrigin"
	>
		<typography variant="p/base_regular" class="text-block__body">
			<app-report-rich-text
				[text]="block.text"
				[field]="field"
				[editorMode]="editorMode"
				[showEdited]="false"
				[placeholder]="placeholder"
				[marks]="marks"
				(typing)="onTyping($event)"
				(keyPressed)="onKey($event)"
				(finished)="closeSlashMenu()"
			></app-report-rich-text>
		</typography>

		<app-report-figure-flags
			*ngIf="place"
			[place]="place"
		></app-report-figure-flags>

		<!-- EDITOR ONLY: it opens on typing, which needs the editor. -->
		<ng-template
			cdkConnectedOverlay
			[cdkConnectedOverlayOrigin]="origin"
			[cdkConnectedOverlayOpen]="slashOpen"
			[cdkConnectedOverlayPositions]="slashPositions"
		>
			<!-- mousedown kept off the options: the field stays focused, so a
			     pick lands in the block it was typed in. -->
			<div
				class="slash-menu"
				role="listbox"
				aria-label="Insert"
				(mousedown)="$event.preventDefault()"
			>
				<button
					*ngFor="let option of slashOptions; let index = index"
					type="button"
					role="option"
					class="slash-menu__option"
					[class.slash-menu__option--active]="index === slashIndex"
					[attr.aria-selected]="index === slashIndex"
					(mouseenter)="slashIndex = index"
					(click)="pick(option)"
				>
					<typography variant="p/sm_medium" class="slash-menu__label">
						{{ option.label }}
					</typography>
					<typography variant="p/xs_regular" class="slash-menu__hint">
						{{ option.description }}
					</typography>
				</button>
			</div>
		</ng-template>
	</div>
</ng-container>
